export const PORT_LIST = [
	{ value: 'Fukuoka', label: 'Fukuoka' },
	{ value: 'Hakata', label: 'Hakata' },
	{ value: 'Hitachinaka', label: 'Hitachinaka' },
	{ value: 'Kanagawa', label: 'Kanagawa' },
	{ value: 'Kanda', label: 'Kanda' },
	{ value: 'Kawasaki', label: 'Kawasaki' },
	{ value: 'Kisarazu', label: 'Kisarazu' },
	{ value: 'Kobe', label: 'Kobe' },
	{ value: 'Nagoya', label: 'Nagoya' },
	{ value: 'Nigata', label: 'Nigata' },
	{ value: 'Osaka', label: 'Osaka' },
	{ value: 'Sakaisenboku', label: 'Sakaisenboku' },
	{ value: 'Senboku', label: 'Senboku' },
	{ value: 'Yokohama', label: 'Yokohama' }
];